(function () {
  function init(root) {
    if (!root || root.dataset.rtpS2Ready) return;
    root.dataset.rtpS2Ready = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var milestones = root.querySelectorAll('.rtp-s2__ms');
    var reveal = root.querySelector('[data-rtp-s2-reveal]');

    function lightThrough(n) {
      milestones.forEach(function (el) {
        var i = parseInt(el.getAttribute('data-ms'), 10);
        if (i <= n && i < 4) el.classList.add('is-lit');
        else if (i === 4 && n >= 3) el.classList.add('is-lit'); // outline only emphasis
        else if (i > n) el.classList.remove('is-lit');
      });
    }

    function showReveal() {
      if (!reveal) return;
      reveal.hidden = false;
      // force reflow for transition
      void reveal.offsetWidth;
      reveal.classList.add('is-shown');
    }

    if (reduce) {
      root.classList.add('is-drawn');
      lightThrough(3);
      showReveal();
      return;
    }

    var stepped = false;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || stepped) return;
          stepped = true;
          root.classList.add('is-drawn');
          // Stagger illuminate 01 → 02 → 03, then reveal
          setTimeout(function () { lightThrough(1); }, 180);
          setTimeout(function () { lightThrough(2); }, 480);
          setTimeout(function () {
            lightThrough(3);
            showReveal();
          }, 820);
          io.disconnect();
        });
      },
      { threshold: 0.28, rootMargin: '0px 0px -8% 0px' }
    );

    var timeline = root.querySelector('[data-rtp-s2-timeline]');
    if (timeline) io.observe(timeline);
    else io.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-rtp-s2]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
